/**
 * Pure helper that turns a scalar amplitude into 5 per-bar heights.
 *
 * This is intentionally side-effect free so it can be unit tested and reused
 * by the (separate) amplitude loop that writes `--vc-b0`..`--vc-b4`.
 *
 * @param {number} level current amplitude in [0,1] of whoever holds the floor
 * @param {number} t     a monotonically increasing time value (seconds)
 * @param {number} [drive=1] multiplier on the modulated portion
 * @returns {number[]} array of 5 values in [0,1]
 */
export function barsFromLevel(level, t, drive = 1) {
  const lvl = Number.isFinite(level) ? Math.max(0, level) : 0;
  const time = Number.isFinite(t) ? t : 0;
  const d = Number.isFinite(drive) ? drive : 1;

  return Array.from({ length: 5 }, (_, i) => {
    const value = 0.2 + Math.abs(Math.sin(time * (9 + i * 2.3) + i)) * lvl * d;
    return Math.min(1, value);
  });
}

export default barsFromLevel;
